import React from 'react';
import PromoTag from '@jbhi-fi/lanyard-ui/components/PromoTag';
import { styles } from './PromoTags.css';
import { PromoTag as PromoTagType } from '@jbhi-fi/components/src/ProductCard/utils/getTags';

const CLICKABLE_TAGS = ['competition', 'signed offer', 'bonus offer', 'jb gift card'];

const handleTagClick = () => {
  const targetElement = document.getElementById('special-offers');
  if (!targetElement) return;

  targetElement.scrollIntoView({ behavior: 'smooth' });
  window.location.hash = '#special-offers';
};

type PromoTagsProps = {
  promoTags?: Array<PromoTagType> | null;
};

export const PromoTags = ({ promoTags }: PromoTagsProps) => {
  if (!promoTags || !promoTags.length) return null;

  return (
    <div className={styles.container} data-testid="promo-tags">
      {promoTags.map(tag => {
        const isClickable = CLICKABLE_TAGS.includes(tag.label.toLowerCase());
        return (
          <PromoTag
            size="lg"
            key={tag.label}
            label={tag.label}
            onClick={isClickable ? () => handleTagClick() : undefined}
          />
        );
      })}
    </div>
  );
};
